import Button from "@/components/ui/button"
import CustomInput from "@/components/ui/input"
import useNotification from "@/hooks/use-notification"
import { authApi } from "../services/auth.api"
import { t } from "i18next"
import React, { useState } from "react"
import styles from "../styles/login.module.scss"
import Email from "@/components/icons/email"
import BackButton from "./BackButton"

interface ForgotPasswordProps {
  onBack?: () => void
  onSuccess: (email: string) => void
  domainID: string
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({
  onBack,
  onSuccess,
}) => {
  const [email, setEmail] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const { notifyError, notifySuccess } = useNotification()

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!email.trim()) {
      notifyError(t("login.emailRequired"))
      return
    }

    setIsLoading(true)

    try {
      await authApi.forgotPassword({ email: email.trim() })
      notifySuccess(t("login.otpSent"))
      onSuccess(email.trim())
    } catch (err: any) {
      const errorMessage = err?.response?.data?.message || t("login.passwordResetFailed")
      notifyError(errorMessage)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className={styles["forgot-password"]}>
      {onBack && <BackButton onClick={onBack} />}

            <div className={styles["forgot-password-header"]}>
                <h2>{t("login.forgotPasswordTitle")}</h2>
                <p>
                    {t("login.forgotPasswordDescription")}
                </p>
            </div>

            <form onSubmit={handleSubmit} className={styles["forgot-password-form"]}>
                <CustomInput
                    label={t("login.email")}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                    placeholder={t("login.emailPlaceholder")}
                    type="email"
                    startIcon={<Email width={24} height={24} />}
                    value={email}
                />
      <Button
        color="primary"
        size="medium"
        style={{ marginTop: "2rem", width: "100%" }}
        type="submit"
        variant="contained"
        disabled={isLoading}
      >
        {isLoading ? t("common.loading") : t("login.resetPassword")}
      </Button>
            </form>
        </div>
    )
}

export default ForgotPassword

